import React from 'react';
import { useCodebookCodes } from 'hooks/codes/useCodebookCodes';
import { useProjectWithErrorHandling } from 'hooks/projects/useProjectWithErrorHandling';
import CodeBook from './CodeBook';
import CodeBookContainerContentWrapper from './CodeBookContainerContentWrapper';

function CodeBookContainer({
  projectID,
  onboardingState,
  hasEditPermission,
  codeID
}) {
  // Check if project exists and handle 404
  const { NotFoundComponent } = useProjectWithErrorHandling(projectID);
  
  // Use the custom hook with collapse state
  const { codes } = useCodebookCodes(projectID);
  
  if (NotFoundComponent) {
    return <NotFoundComponent />;
  }

  return (
    <CodeBookContainerContentWrapper
      onboardingState={onboardingState}
      hasEditPermission={hasEditPermission}
      projectID={projectID}
      hasCodes={onboardingState.hasCodes}
    >
      <CodeBook
        codes={codes}
          projectID={projectID}
        codeID={codeID}
        hasEditPermission={hasEditPermission}
      />
    </CodeBookContainerContentWrapper>
  );
}

export default CodeBookContainer;